import React from 'react';
import { Toast } from 'react-bootstrap';
import type { NotificationTO } from '../../../lib';

interface NotificationItemProps {
  onClickItem: (notification: NotificationTO) => void;
  notification: NotificationTO;
}
const NotificationItem = ({
  notification,
  onClickItem,
}: NotificationItemProps) => {
  const isRead = !!notification.read_at;
  return (
    <div
      className={`notification-item-container ${isRead ? 'notification-read' : ''}`}
    >
      <Toast.Body
        className="notification-item"
        onClick={() => onClickItem(notification)}
      >
        <span
          className={`notification-title ${isRead ? 'notification-read' : ''}`}
        >
          {notification.title}
        </span>
        <span>{notification.content}</span>
      </Toast.Body>
    </div>
  );
};

export default NotificationItem;
